import { useState } from 'react';
import { Apps } from 'constants/global';
import Questions from 'features/bot-builder/components/Common/Questions';
import { WelcomeHero } from '../components/GetStarted/WelcomeHero';
import { PodcastGeneratorForm } from '../components/GetStarted/PodCastGeneratorForm';
import PodCastFormAssignVoices from './../components/GetStarted/PodCastFormAssignVoices';

export default function GetStartedPage() {
  const [step, setStep] = useState(false);

  return (
    <main className="max-md:pb-10 md:h-[calc(100vh-102px)] bg-background-main">
      <div className="bg-gradient-light dark:bg-gradient-dark bg-no-repeat bg-cover lg:rounded-lg lg:rounded-b-none lg:border-b-0 pb-8 lg:pb-10">
        <div className="container mx-auto px-4 py-6 lg:py-14 lg:px-11 lg:max-w-7xl">
          {!step ? (
            <div className="flex flex-col md:flex-row md:gap-16">
              <div className="mb-6 lg:mb-0">
                <WelcomeHero />
              </div>
              <div className="flex-1">
                <PodcastGeneratorForm onAssignVoice={() => setStep(true)} />
              </div>
            </div>
          ) : (
            <div className="flex flex-col lg:flex-row lg:gap-30">
              <PodCastFormAssignVoices onAssignVoice={() => setStep(false)} />
            </div>
          )}
        </div>
      </div>

      {!step && <Questions appType={Apps.PODCAST} />}
    </main>
  );
}
